import script from "./Datasets.vue?vue&type=script&setup=true&lang=js"
export * from "./Datasets.vue?vue&type=script&setup=true&lang=js"

import "./Datasets.vue?vue&type=style&index=0&id=1e2477c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e2477c2"]])

export default __exports__